import axios from "axios";
import { Button, DataGrid, FilterBuilder, SelectBox } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  GroupItem,
  GroupPanel,
  HeaderFilter,
  Item,
  Paging,
  Scrolling,
  SearchPanel,
  Sorting,
  Summary,
  Toolbar,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useState } from "react";
import { classifWork, div } from "./data";
import PivotGridByTask from "./PivotGridByTask";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";

export default function IndividualReportGridRight(props) {
  const { projectName, yearMonth, fullScreen, setFullScreen } = props;

  const [value, setValue] = useState(null);
  const [gridFilterValue, setGridFilterValue] = useState(null);
  const [divValue, setDivValue] = useState(null);
  const [yearMonthValue, setYearMonthValue] = useState(null);
  const [employeeValue, setEmployeeValue] = useState(null);

  // const [pivotGridVisible, setPivotGridVisible] = useState(false);
  // const [cTask, setCTask] = useState(null);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["contrNo", "codeNo", "SEQ"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/workR/individualReportRight?div=${divValue}&yearMonth=${yearMonthValue}&employee=${employeeValue}`
          );

          return result.data;
        },
      })
    );
  }, [divValue, yearMonthValue, employeeValue]);

  const [employee, setEmployee] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee?div=${divValue}`
    );

    console.debug("divValue", divValue);
    console.debug("result", result.data);

    setEmployee(result.data);
  }, [divValue]);

  // const onClick = (e) => {
  //   console.debug("[onClick]");
  //   console.debug("e", e);

  //   setPivotGridVisible(true);
  //   setCTask(e.row.data);
  // };

  const fields = [
    {
      dataField: "classifWork",
      caption: "Classification of Work",
      dataType: "string",
      groupIndex: 0,
      sortOrder: "desc",
      lookup: {
        dataSource: classifWork,
      },
    },
    {
      dataField: "name",
      caption: "Project Name",
      width: 300,
      dataType: "string",
      groupIndex: 1,
      sortOrder: "desc",
      lookup: {
        dataSource: projectName,
      },
    },
    {
      dataField: "taskCat",
      caption: "Task Category",
      dataType: "string",
      groupIndex: 2,
    },
    {
      dataField: "detTask",
      caption: "Detailed Task",
      dataType: "string",
      // groupIndex: 3,
    },
    {
      dataField: "subject",
      caption: "Subject",
      dataType: "string",
    },
    {
      dataField: "sumOfWorkTime",
      caption: "합계: Working Time (h)",
      dataType: "number",
      width: 140,
    },
    {
      dataField: "avgOfWorkTime",
      caption: "평균: Working Time (h)",
      dataType: "number",
      width: 140,
    },
    // {
    //   type: "buttons",
    //   buttons: [
    //     {
    //       hint: "Details",
    //       icon: "fa-solid fa-magnifying-glass-plus",
    //       onClick: onClick,
    //     },
    //   ],
    // },
  ];

  const onValueChanged = useCallback(
    (e) => {
      setValue(e.value);
    },
    [setValue]
  );

  const onDivValueChanged = useCallback((e) => {
    setDivValue(e.value);
    setEmployeeValue(null);
  }, []);

  const onYearMonthValueChanged = useCallback((e) => {
    setYearMonthValue(e.value);
  }, []);

  const onEmployeeValueChanged = useCallback((e) => {
    setEmployeeValue(e.value);
  });

  const buttonClick = useCallback(() => {
    setGridFilterValue(value);
  }, [value, setGridFilterValue]);

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Individual Report");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          "Individual Report.xlsx"
        );
      });
    });

    e.cancel = true;
  };

  const onMinMaxIconClick = () => {
    setFullScreen(!fullScreen);
  };

  return (
    // <div style={{ margin: "16px 16px" }} id={"individualReportRight"}>
    <div id={"individualReportRight"}>
      <div className="filter-container">
        <div className="dx-fieldset">
          <div className="dx-field">
            <div className="dx-field-label">Year-Month: </div>
            <div className="dx-field-value">
              <SelectBox
                items={yearMonth}
                placeholder="Choose Year-Month"
                showClearButton={true}
                // displayExpr={"div"}
                // valueExpr={"div"}
                value={yearMonthValue}
                onValueChanged={onYearMonthValueChanged}
              />
            </div>
          </div>
          <div className="dx-field">
            <div className="dx-field-label">Division:</div>
            <div className="dx-field-value">
              <SelectBox
                items={div}
                placeholder="Choose Division"
                showClearButton={true}
                // displayExpr={"div"}
                // valueExpr={"div"}
                value={divValue}
                onValueChanged={onDivValueChanged}
              />
            </div>
          </div>
          <div className="dx-field">
            <div className="dx-field-label">Employee:</div>
            <div className="dx-field-value">
              <SelectBox
                items={employee}
                placeholder="Choose Employee"
                showClearButton={true}
                displayExpr={"name"}
                valueExpr={"employeeNo"}
                value={employeeValue}
                onValueChanged={onEmployeeValueChanged}
              />
            </div>
          </div>
        </div>
        <div className="dx-clearfix" />

        <FilterBuilder
          fields={fields}
          value={value}
          onValueChanged={onValueChanged}
        />
        <Button text="Apply Filter" type="default" onClick={buttonClick} />
        <div className="dx-clearfix" />
        <DataGrid
          id="individualReportGridRight"
          dataSource={dataSource}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode="widget"
          showBorders={true}
          showRowLines={true}
          showColumnLines={true}
          width={"100%"}
          height={"auto"}
          columnAutoWidth={true}
          wordWrapEnabled={true}
          style={{
            maxHeight: `calc(100vh - 260px)`,
            // maxHeight: `calc(100vh - 385px)`,
            // marginLeft: "10px",
            // marginRight: "10px",
          }}
          columns={fields}
          filterValue={gridFilterValue}
          onExporting={onExporting}
        >
          <ColumnChooser enabled={true} />
          <SearchPanel
            visible={true}
            highlightCaseSensitive={true}
            width={240}
          />
          <Scrolling
            mode={"virtual"}
            rowRenderingMode={"virtual"}
            columnRenderingMode={"virtual"}
            showScrollbar={"always"}
          />
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter={"auto"} />
          <Paging enabled={false} />
          <Sorting mode={"multiple"} />
          <GroupPanel visible={true} />
          <Export enabled={true} />

          {/* <Column
            dataField={"classifWork"}
            caption={"Classification of Work"}
            dataType={"string"}
            groupIndex={0}
          />
          <Column
            dataField={"name"}
            caption={"Project Name"}
            width={300}
            dataType={"string"}
            groupIndex={1}
          />
          <Column
            dataField={"taskCat"}
            caption={"Task Category"}
            dataType={"string"}
            groupIndex={2}
          />
          <Column
            dataField={"detTask"}
            caption={"Detailed Task"}
            dataType={"string"}
            groupIndex={3}
          />
          <Column
            dataField={"subject"}
            caption={"Subject"}
            dataType={"string"}
          />
          <Column
            dataField={"sumOfWorkTime"}
            caption={"합계: Working Time (h)"}
            dataType={"number"}
            width={140}
          />
          <Column
            dataField={"avgOfWorkTime"}
            caption={"평균: Working Time (h)"}
            dataType={"number"}
            width={140}
          /> */}

          <Summary>
            <GroupItem
              column={"sumOfWorkTime"}
              summaryType={"sum"}
              valueFormat={{
                type: "fixedPoint",
                precision: 2,
              }}
              showInGroupFooter={false}
              alignByColumn={true}
              displayFormat={"{0}"}
            />
            <GroupItem
              column={"avgOfWorkTime"}
              summaryType={"sum"}
              valueFormat={{
                type: "fixedPoint",
                precision: 2,
              }}
              showInGroupFooter={false}
              alignByColumn={true}
              displayFormat={"{0}"}
            />
          </Summary>

          <Toolbar>
            <Item location={"before"} name={"groupPanel"} />
            {/* <Item location={"after"}>
              <Button
                onClick={onMinMaxIconClick}
                icon={
                  fullScreen ? `fa-solid fa-minimize` : `fa-solid fa-maximize`
                }
              ></Button>
            </Item> */}
            <Item name={"exportButton"} />
            <Item location="after" name={"columnChooserButton"} />
            <Item name={"searchPanel"} />
          </Toolbar>
        </DataGrid>
        {/* {cTask && (
          <PivotGridByTask
            pivotGridVisible={pivotGridVisible}
            setPivotGridVisible={setPivotGridVisible}
            task={cTask}
          />
        )} */}
      </div>
    </div>
  );
}
